import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import Bag from 'features/processFlowDiagrams/svg/vessels/bag.svg?react'
import BagIso from 'features/processFlowDiagrams/svg/vessels/bag-iso.svg?react'
import BarrelDrum from 'features/processFlowDiagrams/svg/vessels/barrel-drum.svg?react'
import BarrelDrumIso from 'features/processFlowDiagrams/svg/vessels/barrel-drum-iso.svg?react'
import BunkerConicalBottom from 'features/processFlowDiagrams/svg/vessels/bunker-conical-bottom.svg?react'
import ConcreteTank from 'features/processFlowDiagrams/svg/vessels/concrete-tank.svg?react'
import ContainerSolidsLiquidsGases from 'features/processFlowDiagrams/svg/vessels/container-solids-liquids-gases.svg?react'
import ContainerTankCistern from 'features/processFlowDiagrams/svg/vessels/container-tank-cistern.svg?react'
import ContainerTankCisternBoot from 'features/processFlowDiagrams/svg/vessels/container-tank-cistern-boot.svg?react'
import ContainerTankCisternBottom from 'features/processFlowDiagrams/svg/vessels/container-tank-cistern-bottom.svg?react'
import ContainerTankCisternLegs from 'features/processFlowDiagrams/svg/vessels/container-tank-cistern-legs.svg?react'
import DoubleConcreteTank from 'features/processFlowDiagrams/svg/vessels/double-concrete-tank.svg?react'
import DrumOrCondenser from 'features/processFlowDiagrams/svg/vessels/drum-or-condenser.svg?react'
import ForcedDraftCoolingTower from 'features/processFlowDiagrams/svg/vessels/forced-draft-cooling-tower.svg?react'
import Furnace from 'features/processFlowDiagrams/svg/vessels/furnace.svg?react'
import Furnace2 from 'features/processFlowDiagrams/svg/vessels/furnace2.svg?react'
import GasBottle from 'features/processFlowDiagrams/svg/vessels/gas-bottle.svg?react'
import GasHolder from 'features/processFlowDiagrams/svg/vessels/gas-holder.svg?react'
import HalfPipeMixingVessel from 'features/processFlowDiagrams/svg/vessels/half-pipe-mixing-vessel.svg?react'
import InducedDraftCoolingTower from 'features/processFlowDiagrams/svg/vessels/induced-draft-cooling-tower.svg?react'
import JacketedMixingVessel from 'features/processFlowDiagrams/svg/vessels/jacketed-mixing-vessel.svg?react'
import KnockOutDrum from 'features/processFlowDiagrams/svg/vessels/knock-out-drum.svg?react'
import Mixer from 'features/processFlowDiagrams/svg/vessels/mixer.svg?react'
import MixingReactor from 'features/processFlowDiagrams/svg/vessels/mixing-reactor.svg?react'
import OpenBulkStorage from 'features/processFlowDiagrams/svg/vessels/open-bulk-storage.svg?react'
import PressurizedVessel from 'features/processFlowDiagrams/svg/vessels/pressurized-vessel.svg?react'
import PropAgitator from 'features/processFlowDiagrams/svg/vessels/prop-agitator.svg?react'
import Reactor from 'features/processFlowDiagrams/svg/vessels/reactor.svg?react'
import SettlingTank from 'features/processFlowDiagrams/svg/vessels/settling-tank.svg?react'
import SprayDrier from 'features/processFlowDiagrams/svg/vessels/spray-drier.svg?react'
import StorageSphere from 'features/processFlowDiagrams/svg/vessels/storage-sphere.svg?react'
import Tank from 'features/processFlowDiagrams/svg/vessels/tank.svg?react'
import TankBoot from 'features/processFlowDiagrams/svg/vessels/tank-boot.svg?react'
import TankConcreteBase from 'features/processFlowDiagrams/svg/vessels/tank-concrete-base.svg?react'
import TankConicalBottom from 'features/processFlowDiagrams/svg/vessels/tank-conical-bottom.svg?react'
import TankConicalRoof from 'features/processFlowDiagrams/svg/vessels/tank-conical-roof.svg?react'
import TankConicalRoofAndBottom from 'features/processFlowDiagrams/svg/vessels/tank-conical-roof-and-bottom.svg?react'
import TankCovered from 'features/processFlowDiagrams/svg/vessels/tank-covered.svg?react'
import TankCoveredBoot from 'features/processFlowDiagrams/svg/vessels/tank-covered-boot.svg?react'
import TankDishedRoof from 'features/processFlowDiagrams/svg/vessels/tank-dished-roof.svg?react'
import TankDishedRoofConicalBottom from 'features/processFlowDiagrams/svg/vessels/tank-dished-roof-conical-bottom.svg?react'
import TankFalseBottom from 'features/processFlowDiagrams/svg/vessels/tank-false-bottom.svg?react'
import TankFloatingRoof from 'features/processFlowDiagrams/svg/vessels/tank-floating-roof.svg?react'
import TankFloatingRoofBoot from 'features/processFlowDiagrams/svg/vessels/tank-floating-roof-boot.svg?react'
import TankVessel from 'features/processFlowDiagrams/svg/vessels/tank-vessel.svg?react'
import Tower from 'features/processFlowDiagrams/svg/vessels/tower.svg?react'
import TowerWithPacking from 'features/processFlowDiagrams/svg/vessels/tower-with-packing.svg?react'
import TurbineAgitator from 'features/processFlowDiagrams/svg/vessels/turbine-agitator.svg?react'
import VentBent from 'features/processFlowDiagrams/svg/vessels/vent-bent.svg?react'
import VentCover from 'features/processFlowDiagrams/svg/vessels/vent-cover.svg?react'
import VesselDifferentDiameters from 'features/processFlowDiagrams/svg/vessels/vessel-different-diameters.svg?react'
import VesselDishedBottomSurfaceIndication from 'features/processFlowDiagrams/svg/vessels/vessel-dished-bottom-surface-indication.svg?react'
import VesselDishedEndsBrackets from 'features/processFlowDiagrams/svg/vessels/vessel-dished-ends-brackets.svg?react'
import VesselDishedEndsElectricalHeating from 'features/processFlowDiagrams/svg/vessels/vessel-dished-ends-electrical-heating.svg?react'
import VesselDishedEndsHeatingCoolingJacket from 'features/processFlowDiagrams/svg/vessels/vessel-dished-ends-heating-cooling-jacket.svg?react'
import VesselDishedEndsLegs from 'features/processFlowDiagrams/svg/vessels/vessel-dished-ends-legs.svg?react'
import VesselDishedEndsRing from 'features/processFlowDiagrams/svg/vessels/vessel-dished-ends-ring.svg?react'
import VesselDishedEndsSkirts from 'features/processFlowDiagrams/svg/vessels/vessel-dished-ends-skirts.svg?react'
import VesselDishedEndsThermalInsulation from 'features/processFlowDiagrams/svg/vessels/vessel-dished-ends-thermal-insulation.svg?react'
import VesselDome from 'features/processFlowDiagrams/svg/vessels/vessel-dome.svg?react'
import VesselFullTubeHeatingCoolingCoil from 'features/processFlowDiagrams/svg/vessels/vessel-full-tube-heating-cooling-coil.svg?react'
import VesselPit from 'features/processFlowDiagrams/svg/vessels/vessel-pit.svg?react'
import VesselSemiTubeHeatingCoolingCoil from 'features/processFlowDiagrams/svg/vessels/vessel-semi-tube-heating-cooling-coil.svg?react'
import React from 'react'

export const PID_VESSELS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'bag',
    name: 'Bag',
    category: 'vessels',
    svgContent: <Bag />,
    viewBox: '0 0 50 95',
  },
  {
    id: 'bag-iso',
    name: 'Bag (ISO)',
    category: 'vessels',
    svgContent: <BagIso />,
    viewBox: '0 0 50 95',
  },
  {
    id: 'barrel-drum',
    name: 'Barrel, Drum',
    category: 'vessels',
    svgContent: <BarrelDrum />,
    viewBox: '0 0 62 100',
  },
  {
    id: 'barrel-drum-iso',
    name: 'Barrel, Drum (ISO)',
    category: 'vessels',
    svgContent: <BarrelDrumIso />,
    viewBox: '0 0 60 100',
  },
  {
    id: 'bunker-conical-bottom',
    name: 'Bunker (Conical Bottom)',
    category: 'vessels',
    svgContent: <BunkerConicalBottom />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'concrete-tank',
    name: 'Concrete Tank',
    category: 'vessels',
    svgContent: <ConcreteTank />,
    viewBox: '0 0 160 75',
  },
  {
    id: 'container-tank-cistern',
    name: 'Container, Tank, Cistern',
    category: 'vessels',
    svgContent: <ContainerTankCistern />,
    viewBox: '0 0 100 70',
  },
  {
    id: 'container-tank-cistern-boot',
    name: 'Container, Tank, Cistern (Boot)',
    category: 'vessels',
    svgContent: <ContainerTankCisternBoot />,
    viewBox: '0 0 100 80',
  },
  {
    id: 'container-tank-cistern-bottom',
    name: 'Container, Tank, Cistern (Bottom)',
    category: 'vessels',
    svgContent: <ContainerTankCisternBottom />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'container-tank-cistern-legs',
    name: 'Container, Tank, Cistern (Legs)',
    category: 'vessels',
    svgContent: <ContainerTankCisternLegs />,
    viewBox: '0 0 100 105',
  },
  {
    id: 'container-solids-liquids-gases',
    name: 'Container (Solids, Liquids, Gases)',
    category: 'vessels',
    svgContent: <ContainerSolidsLiquidsGases />,
    viewBox: '0 0 150 50',
  },
  {
    id: 'double-concrete-tank',
    name: 'Double Concrete Tank',
    category: 'vessels',
    svgContent: <DoubleConcreteTank />,
    viewBox: '0 0 160 75',
  },
  {
    id: 'drum-or-condenser',
    name: 'Drum or Condenser',
    category: 'vessels',
    svgContent: <DrumOrCondenser />,
    viewBox: '0 0 91 30',
  },
  {
    id: 'forced-draft-cooling-tower',
    name: 'Forced-Draft Cooling Tower',
    category: 'vessels',
    svgContent: <ForcedDraftCoolingTower />,
    viewBox: '0 0 99 99',
  },
  {
    id: 'furnace',
    name: 'Furnace',
    category: 'vessels',
    svgContent: <Furnace />,
    viewBox: '0 0 80 99',
  },
  {
    id: 'furnace2',
    name: 'Furnace2',
    category: 'vessels',
    svgContent: <Furnace2 />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'gas-bottle',
    name: 'Gas Bottle',
    category: 'vessels',
    svgContent: <GasBottle />,
    viewBox: '0 0 35 95',
  },
  {
    id: 'gas-holder',
    name: 'Gas Holder',
    category: 'vessels',
    svgContent: <GasHolder />,
    viewBox: '0 0 70 95',
  },
  {
    id: 'half-pipe-mixing-vessel',
    name: 'Half Pipe Mixing Vessel',
    category: 'vessels',
    svgContent: <HalfPipeMixingVessel />,
    viewBox: '0 0 100 173',
  },
  {
    id: 'induced-draft-cooling-tower',
    name: 'Induced-Draft Cooling Tower',
    category: 'vessels',
    svgContent: <InducedDraftCoolingTower />,
    viewBox: '0 0 98 70',
  },
  {
    id: 'jacketed-mixing-vessel',
    name: 'Jacketed Mixing Vessel',
    category: 'vessels',
    svgContent: <JacketedMixingVessel />,
    viewBox: '0 0 100 174',
  },
  {
    id: 'knock-out-drum',
    name: 'Knock-out Drum',
    category: 'vessels',
    svgContent: <KnockOutDrum />,
    viewBox: '0 0 51 95',
  },
  {
    id: 'mixer',
    name: 'Mixer',
    category: 'vessels',
    svgContent: <Mixer />,
    viewBox: '0 0 20 88',
  },
  {
    id: 'mixing-reactor',
    name: 'Mixing Reactor',
    category: 'vessels',
    svgContent: <MixingReactor />,
    viewBox: '0 0 50 96',
  },
  {
    id: 'open-bulk-storage',
    name: 'Open Bulk Storage',
    category: 'vessels',
    svgContent: <OpenBulkStorage />,
    viewBox: '0 0 100 50',
  },
  {
    id: 'pressurized-vessel',
    name: 'Pressurized Vessel',
    category: 'vessels',
    svgContent: <PressurizedVessel />,
    viewBox: '0 0 100 200',
  },
  {
    id: 'prop-agitator',
    name: 'Prop Agitator',
    category: 'vessels',
    svgContent: <PropAgitator />,
    viewBox: '0 0 20 88',
  },
  {
    id: 'reactor',
    name: 'Reactor',
    category: 'vessels',
    svgContent: <Reactor />,
    viewBox: '0 0 40 95',
  },
  {
    id: 'settling-tank',
    name: 'Settling Tank',
    category: 'vessels',
    svgContent: <SettlingTank />,
    viewBox: '0 0 100 80',
  },
  {
    id: 'spray-drier',
    name: 'Spray Drier',
    category: 'vessels',
    svgContent: <SprayDrier />,
    viewBox: '0 0 100 80',
  },
  {
    id: 'storage-sphere',
    name: 'Storage Sphere',
    category: 'vessels',
    svgContent: <StorageSphere />,
    viewBox: '0 0 80 100',
  },
  {
    id: 'tank-vessel',
    name: 'Tank, Vessel',
    category: 'vessels',
    svgContent: <TankVessel />,
    viewBox: '0 0 100 70',
  },
  {
    id: 'tank',
    name: 'Tank',
    category: 'vessels',
    svgContent: <Tank />,
    viewBox: '0 0 40 95',
  },
  {
    id: 'tank-boot',
    name: 'Tank (Boot)',
    category: 'vessels',
    svgContent: <TankBoot />,
    viewBox: '0 0 100 91',
  },
  {
    id: 'tank-concrete-base',
    name: 'Tank (Concrete Base)',
    category: 'vessels',
    svgContent: <TankConcreteBase />,
    viewBox: '0 0 120 91',
  },
  {
    id: 'tank-conical-bottom',
    name: 'Tank (Conical Bottom)',
    category: 'vessels',
    svgContent: <TankConicalBottom />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'tank-conical-roof',
    name: 'Tank (Conical Roof)',
    category: 'vessels',
    svgContent: <TankConicalRoof />,
    viewBox: '0 0 100 90',
  },
  {
    id: 'tank-conical-roof-and-bottom',
    name: 'Tank (Conical Roof and Bottom)',
    category: 'vessels',
    svgContent: <TankConicalRoofAndBottom />,
    viewBox: '0 0 101 150',
  },
  {
    id: 'tank-covered',
    name: 'Tank (Covered)',
    category: 'vessels',
    svgContent: <TankCovered />,
    viewBox: '0 0 100 75',
  },
  {
    id: 'tank-covered-boot',
    name: 'Tank (Covered, Boot)',
    category: 'vessels',
    svgContent: <TankCoveredBoot />,
    viewBox: '0 0 100 85',
  },
  {
    id: 'tank-dished-roof',
    name: 'Tank (Dished Roof)',
    category: 'vessels',
    svgContent: <TankDishedRoof />,
    viewBox: '0 0 100 95',
  },
  {
    id: 'tank-dished-roof-conical-bottom',
    name: 'Tank (Dished Roof, Conical Bottom)',
    category: 'vessels',
    svgContent: <TankDishedRoofConicalBottom />,
    viewBox: '0 0 100 125',
  },
  {
    id: 'tank-false-bottom',
    name: 'Tank (False Bottom)',
    category: 'vessels',
    svgContent: <TankFalseBottom />,
    viewBox: '0 0 40 112',
  },
  {
    id: 'tank-floating-roof',
    name: 'Tank (Floating Roof)',
    category: 'vessels',
    svgContent: <TankFloatingRoof />,
    viewBox: '0 0 100 70',
  },
  {
    id: 'tank-floating-roof-boot',
    name: 'Tank (Floating Roof, Boot)',
    category: 'vessels',
    svgContent: <TankFloatingRoofBoot />,
    viewBox: '0 0 100 80',
  },
  {
    id: 'tower',
    name: 'Tower',
    category: 'vessels',
    svgContent: <Tower />,
    viewBox: '0 0 14 97',
  },
  {
    id: 'tower-with-packing',
    name: 'Tower With Packing',
    category: 'vessels',
    svgContent: <TowerWithPacking />,
    viewBox: '0 0 14 97',
  },
  {
    id: 'turbine-agitator',
    name: 'Turbine Agitator',
    category: 'vessels',
    svgContent: <TurbineAgitator />,
    viewBox: '0 0 36 93',
  },
  {
    id: 'vent-bent',
    name: 'Vent (Bent)',
    category: 'vessels',
    svgContent: <VentBent />,
    viewBox: '0 0 10 20',
  },
  {
    id: 'vent-cover',
    name: 'Vent (Cover)',
    category: 'vessels',
    svgContent: <VentCover />,
    viewBox: '0 0 10 20',
  },
  {
    id: 'vessel-different-diameters',
    name: 'Vessel (Different Diameters)',
    category: 'vessels',
    svgContent: <VesselDifferentDiameters />,
    viewBox: '0 0 50 97',
  },
  {
    id: 'vessel-dished-bottom-surface-indication',
    name: 'Vessel (Dished Bottom, Surface Indication)',
    category: 'vessels',
    svgContent: <VesselDishedBottomSurfaceIndication />,
    viewBox: '0 0 40 87',
  },
  {
    id: 'vessel-dished-ends-brackets',
    name: 'Vessel (Dished Ends, Brackets)',
    category: 'vessels',
    svgContent: <VesselDishedEndsBrackets />,
    viewBox: '0 0 60 95',
  },
  {
    id: 'vessel-dished-ends-electrical-heating',
    name: 'Vessel (Dished Ends, Electrical Heating)',
    category: 'vessels',
    svgContent: <VesselDishedEndsElectricalHeating />,
    viewBox: '0 0 50 95',
  },
  {
    id: 'vessel-dished-ends-heating-cooling-jacket',
    name: 'Vessel (Dished Ends, Heating-Cooling Jacket)',
    category: 'vessels',
    svgContent: <VesselDishedEndsHeatingCoolingJacket />,
    viewBox: '0 0 52 95',
  },
  {
    id: 'vessel-dished-ends-legs',
    name: 'Vessel (Dished Ends, Legs)',
    category: 'vessels',
    svgContent: <VesselDishedEndsLegs />,
    viewBox: '0 0 40 122',
  },
  {
    id: 'vessel-dished-ends-ring',
    name: 'Vessel (Dished Ends, Ring)',
    category: 'vessels',
    svgContent: <VesselDishedEndsRing />,
    viewBox: '0 0 52 95',
  },
  {
    id: 'vessel-dished-ends-skirts',
    name: 'Vessel (Dished Ends, Skirts)',
    category: 'vessels',
    svgContent: <VesselDishedEndsSkirts />,
    viewBox: '0 0 40 122',
  },
  {
    id: 'vessel-dished-ends-thermal-insulation',
    name: 'Vessel (Dished Ends, Thermal Insulation)',
    category: 'vessels',
    svgContent: <VesselDishedEndsThermalInsulation />,
    viewBox: '0 0 52 95',
  },
  {
    id: 'vessel-dome',
    name: 'Vessel (Dome)',
    category: 'vessels',
    svgContent: <VesselDome />,
    viewBox: '0 0 95 55',
  },
  {
    id: 'vessel-full-tube-heating-cooling-coil',
    name: 'Vessel (Full-Tube Heating-Cooling Coil)',
    category: 'vessels',
    svgContent: <VesselFullTubeHeatingCoolingCoil />,
    viewBox: '0 0 120 70',
  },
  {
    id: 'vessel-pit',
    name: 'Vessel (Pit)',
    category: 'vessels',
    svgContent: <VesselPit />,
    viewBox: '0 0 95 55',
  },
  {
    id: 'vessel-semi-tube-heating-cooling-coil',
    name: 'Vessel (Semi-Tube Heating-Cooling Coil)',
    category: 'vessels',
    svgContent: <VesselSemiTubeHeatingCoolingCoil />,
    viewBox: '0 0 110 70',
  },
]
